// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3jYvD","title":"BackImages_title__235ZC","images":"BackImages_images__qkwYL"};